import { render } from "./SimuladorPrecos.vue?vue&type=template&id=3b2917a4&scoped=true"
import script from "./SimuladorPrecos.vue?vue&type=script&lang=js"
export * from "./SimuladorPrecos.vue?vue&type=script&lang=js"

import "./SimuladorPrecos.vue?vue&type=style&index=0&id=3b2917a4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2917a4"]])

export default __exports__